import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

export default function Privacy() {
  return (
    <div className="min-h-screen" style={{background:'var(--bg-primary)', color:'var(--text-secondary)'}}>
      <header className="px-8 lg:px-16 py-5 flex items-center justify-between" style={{borderBottom:'1px solid var(--border-color)'}}>
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="AHOOW" className="h-10 w-10 rounded-xl" />
          <span className="text-2xl font-black tracking-wide" style={{color:'var(--text-primary)'}}>AH<span className="text-brand-pink">OO</span>W</span>
        </div>
        <Link to="/" className="text-sm flex items-center gap-2 hover:opacity-70" style={{color:'var(--text-muted)'}} data-testid="privacy-back"><ArrowLeft size={16} /> Retour</Link>
      </header>

      <div className="max-w-3xl mx-auto px-8 py-12">
        <div className="flex items-center gap-3 mb-4">
          <Shield size={28} className="text-brand-violet" />
          <h1 className="text-3xl font-black" style={{color:'var(--text-primary)'}}>Politique de Confidentialite</h1>
        </div>
        <p className="text-sm mb-2" style={{color:'var(--text-muted)'}}>Derniere mise a jour : Avril 2026</p>
        <p className="text-sm mb-8" style={{color:'var(--text-muted)'}}>Entite legale : Ahoow LLC &mdash; 8 The Grn R, Dover, DE 19901-3618, Etats-Unis</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-bold mb-3" style={{color:'var(--text-primary)'}}>1. Introduction</h2>
            <p>Ahoow LLC ("Ahoow", "nous", "notre", "nos") exploite l'application mobile AHOOW et le site web <a href="https://www.ahoow.com" className="text-brand-violet underline">www.ahoow.com</a>. Cette politique vous informe de nos pratiques concernant la collecte, l'utilisation, le stockage et la protection de vos donnees personnelles.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold mb-3" style={{color:'var(--text-primary)'}}>2. Restriction d'age</h2>
            <div className="p-4 rounded-xl mb-3" style={{background:'var(--bg-card)', border:'1px solid var(--border-color)'}}>
              <p className="font-bold" style={{color:'var(--text-primary)'}}>Ahoow est strictement reserve aux personnes agees de 18 ans et plus.</p>
            </div>
          </section>
          <section>
            <h2 className="text-lg font-bold mb-3" style={{color:'var(--text-primary)'}}>3. Donnees collectees</h2>
            <p>Informations de compte, profil, communications, donnees d'utilisation et donnees techniques.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold mb-3" style={{color:'var(--text-primary)'}}>4. Securite des donnees</h2>
            <p>Chiffrement SSL/TLS, mots de passe haches bcrypt, tokens JWT, acces restreint.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold mb-3" style={{color:'var(--text-primary)'}}>5. Contact</h2>
            <div className="p-4 rounded-xl" style={{background:'var(--bg-card)'}}>
              <p className="font-semibold mb-2" style={{color:'var(--text-primary)'}}>Ahoow LLC</p>
              <p>8 The Grn R, Dover, DE 19901-3618, Etats-Unis</p>
              <p className="mt-2">Privacy : <a href="mailto:privacy@ahoow.com" className="text-brand-violet underline">privacy@ahoow.com</a></p>
              <p>Support : <a href="mailto:support@ahoow.com" className="text-brand-violet underline">support@ahoow.com</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
